// extracted by mini-css-extract-plugin
export default {"signInBtn":"Form_signInBtn__qyiEd"};